export type NumericProps = {
  value?: string | number
}

function parse(value) {
  if (typeof value === 'string') {
    return Number(value)
  }

  return value
}

function format(value: number) {
  return value.toLocaleString('en-GB')
}

export function Numeric({ value }: NumericProps) {
  if (!value) {
    return <>-</>
  }

  const parsed = parse(value)

  if (Number.isNaN(parsed)) {
    return <>-</>
  }

  return <>{format(parsed)}</>
}
